<template>
    <div class='main'>
        <div class='crumbs'>
            <el-breadcrumb separator='/'>
                <el-breadcrumb-item><i class='el-icon-lx-profile'></i>系统相关</el-breadcrumb-item>
                <el-breadcrumb-item>用户权限</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class='container' style='min-width: 900px'>
            <el-row :gutter='20'>
                <!--部门数据-->
                <el-col :span='6' :xs='24'>
                    <div class='head-container'>
                        <el-input
                            v-model='queryProjectName'
                            placeholder='请输入项目名'
                            clearable
                            size='small'
                            prefix-icon='el-icon-search'
                            style='margin-bottom: 20px'
                        />
                    </div>
                    <div class='head-container'>
                        <el-tree
                            :data='projectTreeOptions'
                            :props='defaultProps'
                            :expand-on-click-node='false'
                            :filter-node-method='filterNode'
                            ref='tree'
                            node-key='id'
                            default-expand-all
                            highlight-current
                            @node-click='handleNodeClick'
                        />
                    </div>
                </el-col>
                <!--用户数据-->
                <el-col :span='18' :xs='24'>
                    <el-form :model='queryParams' ref='queryForm' size='small' :inline='true' label-width='68px'>
                        <el-form-item label='账户名称' prop='userName'>
                            <el-input
                                v-model='queryParams.account'
                                placeholder='请输入账户名称'
                                clearable
                                style='width: 180px'
                                @keyup.enter.native='handleQuery'
                            />
                        </el-form-item>
                        <el-form-item label='角色名称' prop='phonenumber'>
                            <el-input
                                v-model='queryParams.roleName'
                                placeholder='请输入角色名称'
                                clearable
                                style='width: 180px'
                                @keyup.enter.native='handleQuery'
                            />
                        </el-form-item>
                        <el-form-item>
                            <el-button type='primary' icon='el-icon-search' size='mini' @click='handleQuery'>搜索
                            </el-button>
                            <el-button icon='el-icon-refresh' size='mini' @click='resetQuery'>重置</el-button>
                            <el-button
                                type='primary'
                                plain
                                icon='el-icon-plus'
                                size='mini'
                                @click='handleAdd'
                                :disabled='removeProjectGroupStatus'
                            >分配项目组
                            </el-button>
                            
                            <el-button
                                :disabled='!removeProjectGroupStatus'
                                type='danger'
                                plain
                                icon='el-icon-minus'
                                size='mini'
                                @click='handleRemove'
                            >移除项目组
                            </el-button>
                        </el-form-item>
                    </el-form>
                    
                    <el-table stripe v-loading='loading' :data='userList' @selection-change='handleSelectionChange'>
                        <el-table-column type='selection' width='50' align='center' />
                        <el-table-column label='账户名' align='center' prop='account' />
                        <el-table-column label='用户昵称' align='center' prop='nickName'
                                         :show-overflow-tooltip='true' />
                        <el-table-column label='角色' align='roleName' prop='roleName' :show-overflow-tooltip='true'>
                            <template slot-scope='scope'>
                                <span v-if='scope.row.roleList' style='margin-right: 5px' v-for='(item, index) in scope.row.roleList'
                                      :key='index'>{{ item }}</span>
                            </template>
                        </el-table-column>
                        <!--<el-table-column prop='projectGroupList' label='项目组'>-->
                        <!--    <template slot-scope="{ row }">-->
                        <!--        <el-badge :value="row.projectNum" style="margin-top: 9px" type="primary">-->
                        <!--            <el-popover-->
                        <!--                placement="right-start"-->
                        <!--                title="全部项目"-->
                        <!--                width="300"-->
                        <!--                trigger="hover"-->
                        <!--                :content=row.projectList>-->
                        <!--                <el-button slot="reference">{{row.projectId}}</el-button>-->
                        <!--            </el-popover>-->
                        <!--        </el-badge>-->
                        <!--    </template>-->
                        <!--</el-table-column>-->
                        <el-table-column label='项目组' align='projectGroupList' prop='projectGroupList'>
                            <template slot-scope='{ row }'>
                                <el-badge v-if='row.projectGroupList && row.projectGroupList.length > 0' :value='row.projectGroupList.length' style='margin-top: 9px' type='primary'>
                                    <el-popover
                                        placement='right-start'
                                        width='300'
                                        title='加入的项目的组'
                                        trigger='hover'>
                                        <el-tag style='margin: 5px;' type='success' :hit='false' v-for='(item, index) in row.projectGroupList' :key='index'>{{item.name}}</el-tag>
                                        <el-tag slot='reference'>
                                            {{ row.projectGroupList && row.projectGroupList.length > 1 ? '全部项目' : row.projectGroupList[0].name }}
                                        </el-tag>
                                    </el-popover>
                                </el-badge>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label='操作'
                            align='center'
                            width='160'
                            class-name='small-padding fixed-width'
                        >
                            <template slot-scope='scope' v-if='scope.row.userId !== 1'>
                                <el-button
                                    size='mini'
                                    type='text'
                                    icon='el-icon-edit'
                                    @click='handleUpdate(scope.row)'
                                >修改
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-col>
            </el-row>
            
            <!-- 添加或修改用户配置对话框 -->
            <el-dialog :title='title' :visible.sync='open' width='600px' append-to-body>
                <el-form ref='form' label-width='80px'>
                    <el-row>
                        <el-col :span='24' v-if='!removeProjectGroupStatus' style='margin-bottom: 10px'>
                            <el-alert
                                :closable='false'
                                v-if='!updateStatus'
                                :title=computeUserInfo
                                type='warning'>
                            </el-alert>
                            <el-alert
                                :closable='false'
                                v-else
                                :title=computeUserRole
                                type='success'>
                            </el-alert>
                        </el-col>
                        <el-col style='margin-bottom: 10px' v-else :span='24'>
                            <el-alert
                                :closable='false'
                                :title='"在" + currentTreeOption.label + " 中移除用户"'
                                type='warning'>
                            </el-alert>
                        </el-col>
                        <el-col :span='10' v-if='!removeProjectGroupStatus'>
                            <el-form-item :label="updateStatus ? '账户名' : '账户列表'" prop='account'>
                                <el-p v-if='updateStatus'>{{ singleUserGroup.account }}</el-p>
                                <el-select v-else :multiple='true' v-model='multiUserGroup.accountList'
                                           placeholder='请选择用户'>
                                    <el-option
                                        v-for='user in userList'
                                        :key='user.userId'
                                        :label='user.account'
                                        :value='user.userId'
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span='24' v-else>
                            <el-form-item label='用户列表' prop='account'>
                                <el-select :multiple='true' v-model='multiUserGroup.accountList'
                                           placeholder='请选择用户'>
                                    <el-option
                                        v-for='user in userList'
                                        :key='user.userId'
                                        :label='user.account'
                                        :value='user.userId'
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <!--项目组选择-->
                        <el-col :span='14' v-if='!removeProjectGroupStatus'>
                            <el-form-item label='项目组' prop='deptId'>
                                <el-select @change='handleChangeSingle' :multiple='true' v-if='updateStatus'
                                           v-model='singleUserGroup.projectGroupIdList' placeholder='请选择项目组'>
                                    <el-option
                                        v-for='group in projectGroupList'
                                        :key='group.id'
                                        :label='group.name'
                                        :value='group.id'
                                    ></el-option>
                                </el-select>
                                <el-select v-else :multiple='true' v-model='multiUserGroup.projectGroupIdList'
                                           placeholder='请选择项目组'>
                                    <el-option
                                        v-for='group in projectGroupList'
                                        :key='group.id'
                                        :label='group.name'
                                        :value='group.id'
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <div slot='footer' class='dialog-footer'>
                    <el-button type='primary' @click='submitForm'>确 定</el-button>
                    <el-button @click='cancel'>取 消</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>

import { selectProjectGroupList } from '@/components/api/projectGroup';
import { message } from '@/utils/message';
import { selectEmployeeList } from '@/components/api/dashboard';
import { deleteUsersFromProjectGroup, insertProjectGroupsForUsers } from '@/components/api/rolePermission';
import { queryProjectInfoList } from '@/components/api/ProjectInfo';

export default {
    name: 'User',
    data() {
        return {
            // 遮罩层
            loading: true,
            // 选中数组
            ids: [],
            // 总条数
            total: 0,
            userList: [],
            selectUserList: [],
            // 弹出层标题
            title: '',
            // 部门树选项
            projectTreeOptions: [],
            // 是否显示弹出层
            open: false,
            // 项目名
            queryProjectName: undefined,
            singleUserGroup: {
                account: undefined,
                projectGroupIdList: [],
                roleId: undefined,
                roleName: undefined,
                projectGroupName: undefined
            },
            multiUserGroup: {
                accountList: [],
                projectGroupIdList: [],
                projectGroupId: undefined
            },
            defaultProps: {
                children: 'children',
                label: 'label'
            },
            // 查询参数
            queryParams: {
                pageNum: 1,
                pageSize: 10,
                projectName: undefined,
                account: undefined,
                userId: undefined,
                roleName: undefined,
                projectId: undefined,
                roleId: undefined,
                projectGroupIdList: []
                //
            },
            // 项目组集合
            projectGroupList: [],
            projectDataList: [],
            updateStatus: false,
            currentUserInfo: {},
            // currentUserRoleList: [],
            // 当前用户加入的项目组集合
            currentUserProjectGroupList: [],
            removeProjectGroupStatus: false,
            currentProjectGroup: {},
            currentTreeOption: {}
            
        };
    },
    watch: {
        // 根据名称筛选项目组
        queryProjectName(val) {
            this.$refs.tree.filter(val);
        }
    },
    computed: {
        computeUserInfo() {
            return `${this.multiUserGroup.accountList.length} 个用户将被添加到 ${this.multiUserGroup.projectGroupIdList.length}项目组中`;
        },
        computeUserRole() {
            if (!this.currentUserInfo.roleList || this.currentUserInfo.roleList.length === 0) {
                return this.singleUserGroup.account + '并没有加入任何项目组';
            } else {
                return this.singleUserGroup.account + ' 拥有 ' + this.currentUserInfo.roleList.join('、') + ' 权限';
            }
        }
    },
    created() {
        this.getList();
    },
    methods: {
        handleChangeSingle(projectGroupId) {
            this.projectGroupList.forEach(k => {
                if (k.id === projectGroupId) {
                    this.singleUserGroup.projectGroupName = k.name;
                }
            });
        },
        async getProjectInfo() {
            return new Promise((resolve, reject) => {
                const selectProjectGroupPromise = selectProjectGroupList(null, null, null, null, null);
                const selectProjectDataPromise = queryProjectInfoList({pageSize: 10000});
                Promise.all([selectProjectGroupPromise, selectProjectDataPromise])
                    .then(([groupResult, dataResult]) => {
                        if (groupResult.code === 200) {
                            this.projectGroupList = groupResult.data.result;
                        }
                        this.projectDataList = dataResult.data.result;
                        
                        resolve(); // 所有操作完成后，手动resolve Promise
                    })
                    .catch((error) => {
                        reject(error); // 处理可能出现的错误
                    });
            });
        },
        async getData() {
            // 获取所有的项目组
            this.projectTreeOptions = [];
            await this.getProjectInfo();
            new Promise(resolve => {
                const projectSet = new Set();
                this.projectDataList.forEach((project, index) => {
                    projectSet.add({
                        cnName: project.cnName,
                        status: project.status,
                        projectId: project.appId,
                        projectName: project.name,
                        children: [],
                        label: project.cnName,
                        id: project.appId
                    });
                    if (index === this.projectDataList.length - 1) {
                        this.projectTreeOptions = Array.from(projectSet);
                        resolve();
                    }
                });
            }).then(result => {
                this.projectTreeOptions.forEach((project, index1, array) => {
                    this.projectGroupList.forEach((group, index) => {
                        if (group.projectId === project.projectId) {
                            this.projectTreeOptions[index1].children.push(
                                {
                                    id: group.id,
                                    name: group.name,
                                    projectId: project.projectId,
                                    roleId: group.roleId,
                                    label: group.name
                                }
                            );
                        }
                    });
                });
            });
        },
        async getList() {
            this.loading = true;
            this.getData();
            selectEmployeeList(this.queryParams).then(result => {
                if (result.code === 200) {
                    this.userList = result.data;
                    this.loading = false;
                }
            });
        },
        // 筛选节点
        filterNode(value, data) {
            if (!value) return true;
            return data.label.indexOf(value) !== -1;
        },
        // 节点单击事件
        handleNodeClick(data) {
            this.currentTreeOption = data;
            this.removeProjectGroupStatus = true;
            this.queryParams = {};
            if (data.children) {
                this.queryParams.projectId = data.projectId;
            } else {
                this.queryParams.projectGroupIdList = [];
                this.queryParams.projectGroupIdList.push(data.id);
            }
            this.handleQuery();
            this.currentProjectGroup = data;
        },
        // 取消按钮
        cancel() {
            this.open = false;
            this.multiUserGroup.accountList = [];
            this.multiUserGroup.projectGroupIdList = [];
            this.singleUserGroup.account = undefined;
            this.singleUserGroup.projectGroupId = undefined;
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.queryParams.pageNum = 1;
            if (this.queryParams.account) {
                this.userList.forEach((k, v) => {
                    if (k.account === this.queryParams.account) {
                        this.queryParams.userId = k.userId;
                    }
                });
            }
            this.getList();
        },
        /** 重置按钮操作 */
        resetQuery() {
            this.removeProjectGroupStatus = false;
            this.queryParams = {
                pageNum: 1,
                pageSize: 10,
                projectName: undefined,
                account: undefined,
                userId: undefined,
                roleName: undefined,
                projectId: undefined,
                roleId: undefined,
                projectGroupIdList: []
                //
            };
            this.$refs.tree.setCurrentKey(null);
            this.handleQuery();
        },
        // 多选框选中数据
        handleSelectionChange(selection) {
            this.ids = selection.map(item => item.userId);
            this.multiUserGroup.accountList = this.ids;
            this.updateStatus = true;
            this.multiUserGroup.projectGroupIdList = [];
        },
        // 更多操作触发
        handleCommand(command, row) {
            switch (command) {
                case 'handleResetPwd':
                    this.handleResetPwd(row);
                    break;
                case 'handleAuthRole':
                    this.handleAuthRole(row);
                    break;
                default:
                    break;
            }
        },
        /** 新增按钮操作 */
        handleAdd() {
            this.open = true;
            this.title = '分配分组';
            this.multiUserGroup.projectGroupIdList = [];
            this.updateStatus = false;
        },
        handleRemove() {
            this.open = true;
            this.title = '移除项目组';
        },
        /** 修改按钮操作 */
        handleUpdate(row) {
            this.currentUserInfo = row;
            this.open = true;
            this.updateStatus = true;
            this.singleUserGroup.account = row.account;
            this.singleUserGroup.projectGroupIdList = [];
            this.title = '修改项目分组';
            
            // 根据用户信息，查询其角色
            // this.currentUserRoleList = []
            // queryAllUserPermissionRelation({userAdminList: [{userId: row.userId}]}).then(result =>{
            //     if (result.code === 200) {
            //         if (result.data.userRolesAndPermissionsMap) {
            //             let map = result.data.userRolesAndPermissionsMap;
            //             if (map[this.currentUserInfo.account]) {
            //                 for (let k of Object.keys(map[this.currentUserInfo.account])) {
            //                     this.currentUserRoleList.push(k)
            //                 }
            //             }
            //         }
            //     }else {
            //         message.error(result.message)
            //     }
            // })
            
            // 查询此用户加入的项目组
            selectProjectGroupList(null, null, null, null, 1, row.userId).then(result => {
                if (result.code === 200) {
                    this.currentUserProjectGroupList = result.data.result;
                    this.currentUserProjectGroupList.forEach(k => {
                        this.singleUserGroup.projectGroupIdList.push(k.id);
                    });
                } else {
                    message.error('查询用户项目组失败');
                }
            });
        },
        /** 提交按钮 */
        submitForm: function() {
            let userAdminList = [];
            let projectGroupList = [];
            if (this.removeProjectGroupStatus) {
                // 从一个项目组中移除多个用户
                if (!this.multiUserGroup.accountList || this.multiUserGroup.accountList.length === 0) {
                    message.warning('请选择用户');
                    return;
                }
                
                let projectGroupList = [];
                let userAdminList = [];
                this.multiUserGroup.accountList.forEach(userId => {
                    userAdminList.push({
                        userId: userId
                    });
                });
                if (this.currentTreeOption.children) {
                    // 是项目名，查询分组名
                    this.projectGroupList.forEach(k => {
                        if (k.projectId === this.currentTreeOption.projectId) {
                            projectGroupList.push({
                                id: k.id
                            });
                        }
                    });
                } else {
                    // 就是项目分组
                    projectGroupList.push({
                        id: this.currentTreeOption.id
                    });
                }
                let obj = this
                this.$modal.confirm('你将要从' + projectGroupList.length + ' 个项目中移除' + this.multiUserGroup.accountList.length + '个用户').then(function() {
                    for (let i = 0; i < projectGroupList.length; i++) {
                        deleteUsersFromProjectGroup(userAdminList, [projectGroupList[i]]).then(result => {
                            if (i === projectGroupList.length - 1 && result.code === 200) {
                                message.success(result.message);
                                obj.getList();
                                obj.resetQuery();
                                obj.open = false
                            }
                        });
                    }
                });
                return;
            }
            if (this.updateStatus) {
                if (!this.singleUserGroup.projectGroupIdList ||
                    this.singleUserGroup.projectGroupIdList.length === 0) {
                    message.warning('你未为' + this.currentUserInfo.account + '分配项目组');
                    return;
                }
                userAdminList.push({
                    userId: this.currentUserInfo.userId
                });
                this.singleUserGroup.projectGroupIdList.forEach(id => {
                    projectGroupList.push({
                        id: id
                    });
                });
            } else {
                if (!this.multiUserGroup.projectGroupIdList || this.multiUserGroup.projectGroupIdList.length === 0) {
                    message.warning('请选择项目组');
                    return;
                }
                if (!this.multiUserGroup.accountList || this.multiUserGroup.accountList.length === 0) {
                    message.warning('请选择用户');
                    return;
                }
                
                this.multiUserGroup.accountList.forEach(k => {
                    userAdminList.push({
                        userId: k
                    });
                });
                this.multiUserGroup.projectGroupIdList.forEach(k => {
                    projectGroupList.push({
                        id: k
                    });
                });
            }
            let obj = this
            this.$modal.confirm(userAdminList.length + ' 个用户将添加到' + projectGroupList.length + '项目组中').then(function() {
                return insertProjectGroupsForUsers(userAdminList, projectGroupList);
            }).then(result => {
                if (result.code === 200) {
                    obj.getList();
                    obj.open = false;
                }
                message.success(result.message);
            });
        }
    }
};
</script>